import React, { useState, useEffect, useRef } from "react";
import { saveAs } from "file-saver";
import { Button } from "react-bootstrap";
import { CreacionTitulosService } from "../../../../_services/creaciontitulos.service";
import { useSelector } from "react-redux";
import BasicProcessingModal from "../../../../components/LoadingModal/BasicProcessingModal";

const TitleGeneratorHome = () => {
  const [file, setFile] = useState(null);
  const [category, setCategory] = useState("");
  const [lastTitleNumber, setLastTitleNumber] = useState(0);
  const [titleNumberStart, setTitleNumberStart] = useState("");
  const [modalStatus, setModalStatus] = useState({status: null, message: ""}); // "processing", "success", o null  
  
  const fileInputRef = useRef(null);

  const isSubmitDisabled = !file || !category || !titleNumberStart;
  const { user } = useSelector(({ authentication }) => authentication);

  useEffect(() => {
    const getLastTitle = async () => {
      let res = await CreacionTitulosService.getLastTitleNumber();
      setLastTitleNumber(res.data.lastTitleNumber); 
    };
    getLastTitle();
  }, [lastTitleNumber]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
  };

  const handleNumberTitleChange = (e) => {
    setTitleNumberStart(e.target.value);
  };

  const resetFileInput = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const restartStates = () => {
    setTitleNumberStart("");
    setCategory("");
    resetFileInput();
    setLastTitleNumber(0);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      alert("Por favor, selecciona un archivo.");
      return;
    }
    if (titleNumberStart <= lastTitleNumber){
      alert("El número de inicio de los títulos es menor que el último título creado");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    try {
      setModalStatus({status: "processing", message: "Procesando Excel..."});
      const response = await CreacionTitulosService.postGenerateTitles(file, category, user.dni, titleNumberStart);
      const blob = new Blob([response.data], { type: "application/zip" });
      setModalStatus({status: "success", message: "Excel Procesado con éxito!!", time: 3000});
      saveAs(blob, `${file.name.replace(/\.(xls|xlsx)$/, "")}_titulos.zip`);
      restartStates();
    } catch (error) {
      console.error("Error al enviar el archivo", error);
      setModalStatus({status: "error", message: "Error al procesar el excel", time: 3000});
    }
  };

  return (
    <div className="container mt-5">
      <div className="card p-4 shadow">
        <h3 className="text-center mb-4">Generador de Títulos</h3>
        
        <div className="mb-3">
          <label className="form-label">Selecciona una categoría:</label>
          <select className="form-select" value={category} onChange={handleCategoryChange}>
            <option value="">-- Selecciona una opción --</option>
            <option value="inmueble">Inmueble</option>
            <option value="comercio">Comercio</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Último título creado: {lastTitleNumber}</label>
        </div>

        <div className="mb-3">
          <label className="form-label">Número de inicio de títulos:</label>
          <input
            className="form-control"
            type="number"
            min='0'
            value={titleNumberStart}
            onChange={handleNumberTitleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Selecciona un archivo:</label>
          <input
            className="form-control"
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
            ref={fileInputRef}
          />
        </div>

        <div className="text-center">
          <Button variant="primary" onClick={handleSubmit} disabled={isSubmitDisabled}>
            Generar Título
          </Button>
        </div>
      </div>
      <BasicProcessingModal status={modalStatus} onClose={() => setModalStatus({status: undefined, message: ""})} />
    </div>
  );
};

export default TitleGeneratorHome;